import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const ImportDeduction = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	const [docfile,setDocFile]=useState(null);
	
		const handleDocumentChange = (event) => {
			
			const file = event.target.files[0];
			if (file) {
				setDocFile(file);
			//   setPreview(URL.createObjectURL(file)); // Preview image
			}
		  };

	const [user, setUser] = useState({
		start_date: "",
		end_date: "",
	})

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setUser({ ...user, [name]: value });
	}



	const [url_name, setUrlname] = useState('');
	const [url_id, setUrlid] = useState('');
	const [url_link, setUrllink] = useState('');
	const [parent, setParent] = useState('');
	const history = useHistory();
	const [data, setData] = useState([]);
	const [datacount, setDataCount] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [currentPageId, setCurrentPageId] = useState(1);


	// const [anand, setAnand]= useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	// const itemsPerPage = 10;
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	let filteredItems = data.filter((item) =>



		`${item.department_name.toLowerCase()}${item.emp_info.toLowerCase()}${item.shift_code.toLowerCase()}`.includes(searchTerm.toLowerCase())

	);
	const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
	const startIndex = (currentPage - 1) * itemsPerPage;

	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm]);

	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};


	const clearInput = () => {
		setSearchTerm("");
	  };


	const handleRowsPerPageChange = (e) => {
		setItemsPerPage(Number(e.target.value));
		setCurrentPage(1); // Reset to first page
	};



	

	useEffect(() => {
		axios.get(API_BASE_URL + '/weekoff_exceed_list', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData(res.data))
			//  .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])






	var elements = [];
	for (var i = 1; i <= datacount.total_page; i++) {
		elements.push(i);
	}

	//   for(var i=1;i<=datacount.total_page;i++){
	// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
	// 	  {i}
	//   </a></li>);
	// }

	//console.log(elements)

	//   const [currentPage,setCurrentPage]= useState(1);
	const recordsPerPage = 10;

	const lastIndex = currentPage * recordsPerPage;
	const firstIndex = lastIndex - recordsPerPage;
	const records = data.slice(firstIndex, lastIndex);
	const npage = Math.ceil(data.length / recordsPerPage);
	const numbers = [...Array(npage + 1).keys()].slice(1);





	const handleDutyRosterSubmit = (e) => {

		e.preventDefault();

		

		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/importdeduction', {deduction_file:docfile}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};




  

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />

							<div className="section-body mb-4">
								<Link to={`/Addallowance-deduction`}>
								<button className="btn btn-light me-2" >
								Manage Allowance
								</button>
								</Link>
														
								<Link to={`/Import-Allowance`}>
								<button className="btn btn-light me-2" >
								Import Allowance
								</button>
								</Link>
														
								<Link to={`/Import-Deduction`}>
								<button className="btn btn-primary me-2" >
								Import Deduction
								</button>
								</Link>
								</div>

														

							<form>
<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-body">
<div className="row clearfix">

<div className="form-group">
<form onSubmit={handleDutyRosterSubmit}>
<div class="row">
<div className="col-md-12 col-sm-12">


										{/* <div class="row" style={{ display: "flex" }}>
										<button style={{ marginLeft: "auto" }}
											type="button"
											className="btn btn-primary"
											data-toggle="modal"
											data-target="#exampleModal"
											
										>
											Assign Shift
										</button>
									</div> */}
									
{/* <p ></p> */}
										<div className="form-group">
										
									
										 <p class="card-text">The correct column order is <b style={{color:'blue'}} >(Employee ID, Year and Month,Reason,Amount)</b> and you must follow the csv file , otherwise you will get an error while importing the csv file. </p>
                                         <b>For  example '(1105,2021-02,Reason,1000)'</b>
                                          <p style={{color:'red'}}>csv file header is Mandatory </p>

										<label className="form-label">Upload File <span className="form-required">*</span></label>
										<input type="file" onChange={handleDocumentChange} className="block w-full" /><br />
										<span style={{fontSize:'10px',fontWeight:'900'}}>Upload files only: xls, xlsx, csv (allowed file size 500 KB)</span><br />
										{/* <a href={filepath}><span style={{fontSize:'16px',fontWeight:'900',color:'red'}}>{document.document_file}</span></a> */}
										
										</div>
									</div>
									</div>


<button type="submit" className="btn btn-round btn-primary">
Import File
</button>
</form>

</div>


</div>

</div>


</div>
</div>

</form>




						</div>
					</div>


				

				</div>
			</div>




		
			






		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(ImportDeduction);